import type { User } from '../../../utils/loginUtils'
import {
  completeProduct,
  updateProduct,
  type shoppingListProduct,
} from '../../../utils/shoppingListUtils'
import { useState } from 'react'
import Spinner from '../../Spinner/Spinner'

import './ShoppingListEntry.scss'

interface ShoppingListEntryProps {
  user: User
  product: shoppingListProduct
  isMobile: boolean
  openPopup: (product: shoppingListProduct | null) => void
  reLoadData: () => void
}
function ShoppingListEntry({
  user,
  product,
  isMobile,
  openPopup,
  reLoadData,
}: ShoppingListEntryProps) {
  const [isLoading, setIsLoading] = useState(false)

  const onCheckClick = async (e: React.MouseEvent) => {
    e.stopPropagation()
    setIsLoading(true)
    try {
      await completeProduct(user.id!, product)
      reLoadData()
    } finally {
      setIsLoading(false)
    }
  }

  const onDeleteClick = async (e: React.MouseEvent) => {
    e.stopPropagation()
    const newProduct = { ...product!, quantity: 0 }
    setIsLoading(true)
    try {
      await updateProduct(user.id!, newProduct)
      reLoadData()
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div
      key={product.id}
      className="shopping-list-entry"
      onClick={() => openPopup(product)}
    >
      <Spinner isOpen={isLoading} overlay={true} />
      <div
        className={`list-entry ${isMobile ? 'list-entry-mobile' : ''} list-entry-shopping`}
      >
        <div className="shop-product-name">
          <span>{product.product_name}</span>
        </div>
        <div className="shop-product-qty">
          <span>{product.quantity}</span>
        </div>
        <button
          className="shop-product-check"
          onClick={onCheckClick}
          type="button"
        >
          <span>✓</span>
        </button>
        <button
          className="shop-product-delete"
          onClick={onDeleteClick}
          type="button"
        >
          <span>x</span>
        </button>
      </div>
    </div>
  )
}

export default ShoppingListEntry
